export default __webpack_public_path__ + "a08e7d63c08fe17d1be7dbd8eb271162.png";